<template>
  <iv-form
    class="SentimentItem"
    :ref="'sentiment_'+ sentimentList.length"
    :model="formData"
    label-position="top"
    inline
   >
    <iv-form-item label="舆情标题：" prop="title" style="width: 200px">
      <iv-input v-model="formData.title" @on-change="onChange"></iv-input>
    </iv-form-item>
    <iv-form-item label="链接" prop="url" style="flex-grow:1">
      <iv-input v-model="formData.url" placeholder="完整链接，如：http://www.baidu.com/" @on-change="onChange"></iv-input>
    </iv-form-item>
    <iv-form-item label="关联指标：" prop="secondTargetNum" style="width: 200px">
      <iv-select v-model="formData.secondTargetNum" @on-change="onChange">
        <iv-option v-for="(item, i) in secondTargetList" :key="i" :value="item.secondTargetNum">
          {{ item.secondTargetName }}
        </iv-option>
      </iv-select>
    </iv-form-item>
    <iv-form-item label="数量" prop="number" style="width: 65px">
      <iv-input v-model="formData.number" @on-change="onChange"></iv-input>
    </iv-form-item>
    <iv-form-item label=" " style="width: 70px;flex-shrink: 1;">
      <iv-button v-if="sentimentList.length > 1 " size="small" icon="md-remove" type="primary"
        style="margin-top: 5px" @click="handleRemove()">
      </iv-button>
      <iv-button v-if="sentimentList.length < 5 && i == sentimentList.length-1" size="small"
        icon="md-add"
        type="primary" style="margin-top: 5px;margin-left:5px" @click="handleAdd()">
      </iv-button>
    </iv-form-item>
  </iv-form>
</template>
<script>
export default {
  props: {
    value: Object,
    i: Number,
    sentimentList:{
      type: Array,
      default:[]
    },
    secondTargetList:{
      type: Array,
      default:[]
    },
  },
  data() {
    return {
      // TARGET,
      formData:{
        title:"",
        url:"",
        secondTargetNum:"",
        number:1
      },
    };
  },
  methods: {
    handleRemove(){
      this.$emit('handleRemove',{ value: this.value, i: this.i })
    },
    handleAdd(){
      this.$emit('handleAdd',this.i)
    },
    onChange(){
        this.$emit('handleFormData',{formData: this.formData, i:this.i})
    }
  },
  watch:{
    'value'(val){
      this.formData = val
    }
  }
};
</script>
<style lang="scss" scoped>
  .SentimentItem{
    display: flex;
  }
</style>
